<template>
  <div>
    <v-card>
      <v-card-title>
        Add Wholesaler
        <v-spacer></v-spacer>
        <v-btn icon
        ><v-icon color="dark" @click="close">mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-divider class="mx-4 mb-2"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text>
          <v-row>
            <v-col cols="5">
              <ValidationProvider name="Name">
                <v-text-field
                  label="Name"
                  dense
                  outlined
                  clearable
                  v-model="wholesaler.Name"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="5">
              <ValidationProvider name="Network Type">
                <v-select
                  dense
                  outlined
                  v-model="wholesaler.NetworkType"
                  :items="networkType"
                  label="Network Type"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="5">
              <ValidationProvider name="Password Required">
                <v-select
                  dense
                  outlined
                  v-model="wholesaler.PasswordRequired"
                  :items="passwordRequired"
                  label="Password Required"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </ValidationProvider>
            </v-col>

            <v-col cols="5">
              <ValidationProvider name="Supplier Billing Reference Required">
                <v-select
                  dense
                  outlined
                  v-model="wholesaler.SupplierBillingReferenceRequires"
                  :items="supplierBillingReferenceRequired"
                  label="Supplier Billing Reference Required"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-text>
          <v-row>
            <v-col cols="12" class="my-3 py-0 px-0">
              <v-divider class="mx-3"></v-divider>
            </v-col>

            <v-col cols="12" class="text-right">
              <v-btn
                @click.prevent="save"
                color="dark"
                class="white--text mr-4"
                :disabled="!dirty || invalid"
              >Save</v-btn
              >
              <v-btn @click="close">Close</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </ValidationObserver>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "add-wholesaler",
  data: () => ({
    wholesaler: {},
    networkType: [
      { text: "gowireless", value: 'gowireless' },
      { text: "nbn", value: 'ppp_nbn' },
      { text: "dsl", value: 'ppp_dsl' }
    ],
    passwordRequired:[
      { text: "Yes", value: 'y' },
      { text: "No", value: 'n' }
    ],
    supplierBillingReferenceRequired: [
      { text: "Yes", value: 'y' },
      { text: "No", value: 'n' }
    ],
  }),
  methods: {
    close() {
      this.$refs.observer.reset();
      this.wholesaler = {};
      this.$emit("close");
    },
    save() {
      let vm = this;
      var payload = {
        'NetworkType':vm.wholesaler.NetworkType,
        'Name':vm.wholesaler.Name,
        'PasswordRequired':vm.wholesaler.PasswordRequired,
        'SupplierBillingReferenceRequires':vm.wholesaler.SupplierBillingReferenceRequires
      }
      vm.addVispAccount(payload).then((data) => {
        this.$refs.observer.reset();
        this.wholesaler = {};
        this.$emit("save");
      });
    }
  }
}
</script>

<style scoped>

</style>
